module.exports = __webpack_public_path__ + "static/img/cop_sch_logo9.e8c8624a.png";